export default function ValueProposition() {
  const values = [
    {
      icon: 'ri-compass-3-line',
      title: 'Strategy &amp; Roadmapping',
      description: 'Clear AI roadmaps tailored to your organization\'s compliance, operational structure, and growth objectives.',
      image: 'https://public.readdy.ai/ai/img_res/90e56567749993b43336c268471a7c14.jpg'
    },
    {
      icon: 'ri-stack-line',
      title: 'Intelligent System Design',
      description: 'Automation, data intelligence, and decision-support systems engineered for reliability and scalability.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20architecture%20visualization%20showing%20layered%20intelligent%20systems%20and%20automated%20workflows%20with%20clean%20structured%20design%20elements%20in%20deep%20blue%20and%20bright%20cyan%20representing%20scalable%20AI%20infrastructure%20with%20professional%20corporate%20aesthetic&width=400&height=280&seq=value2&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Measurable Performance Gains',
      description: 'Reduced operational friction, improved decision accuracy, and sustainable efficiency improvements.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20data%20visualization%20showing%20upward%20performance%20metrics%20and%20growth%20analytics%20with%20elegant%20line%20charts%20and%20efficiency%20indicators%20in%20navy%20blue%20and%20cyan%20colors%20representing%20measurable%20business%20improvements%20with%20minimalist%20professional%20design&width=400&height=280&seq=value3&orientation=landscape'
    }
  ];

  return (
    <section className="py-32 bg-slate-50">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center mb-20">
          <p className="text-sm uppercase tracking-wider text-slate-500 mb-4">
            Strategic Direction. Intelligent Execution.
          </p>
          <h2 className="text-5xl font-extrabold text-slate-900 leading-tight">
            Built for Measurable Impact
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-10">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden hover:transform hover:-translate-y-1 hover:shadow-xl transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-[280px] overflow-hidden">
                <img 
                  src={value.image}
                  alt={value.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
              </div>
              <div className="p-10">
                <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-5">
                  {value.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
